// @ts-ignore
import dateformat from "dateformat";

class DateUtil {
  static isValidDate(d: Date) {
    return d instanceof Date && !Number.isNaN(d.getTime());
  }

  static getYYYYMMDD(date: Date): string {
    return dateformat(date, "yyyymmdd");
  }

  static getDateString(date: Date): string {
    return dateformat(date, "yyyy-mm-dd");
  }

  static convertToDate(dateString: string): Date {
    const [yearStr, monthStr, dayStr] = dateString.split(/\.|-/);

    const year = Number(yearStr);
    const month = Number(monthStr) - 1;
    const day = Number(dayStr);

    const date = new Date(year, month, day);

    if (month !== date.getMonth() || day !== date.getDate())
      throw new Error("invalid date");

    return date;
  }
}

export default DateUtil;
